import CsvModel from './globals/CsvModel';

export default class DemandsCsvModel extends CsvModel {
  static get path() {
    return '/backend/demands.csv';
  }
}
